import { combineReducers } from "@reduxjs/toolkit";

import { aggregatedDataApi } from "./aggregatedData/api";
import { authApi } from "./auth/api";
import authReducer from "./auth/reducer";
import { branchApi } from "./branch/api";
import { clientsApi } from "./clients/api";
import { contentApi } from "./content/api";
import { contentEditorApi } from "./contentEditor/api";
import { filesApi } from "./files/api";
import { inviteTherapistsApi } from "./inviteTherapists/api";
import { inviteTokensApi } from "./inviteTokens/api";
import { organizationsApi } from "./organizations/api";
import { partnersApi } from "./partners/api";
import { projectsApi } from "./projects/api";
import { relaxationReportsApi } from "./relaxationReports/api";
import { usersApi } from "./users/api";

const rootReducer = combineReducers({
    [authApi.reducerPath]: authApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [organizationsApi.reducerPath]: organizationsApi.reducer,
    [partnersApi.reducerPath]: partnersApi.reducer,
    [inviteTokensApi.reducerPath]: inviteTokensApi.reducer,
    [inviteTherapistsApi.reducerPath]: inviteTherapistsApi.reducer,
    [clientsApi.reducerPath]: clientsApi.reducer,
    [filesApi.reducerPath]: filesApi.reducer,
    [aggregatedDataApi.reducerPath]: aggregatedDataApi.reducer,
    [branchApi.reducerPath]: branchApi.reducer,
    [contentApi.reducerPath]: contentApi.reducer,
    [contentEditorApi.reducerPath]: contentEditorApi.reducer,
    [relaxationReportsApi.reducerPath]: relaxationReportsApi.reducer,
    auth: authReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
